import HookForm from '../../../../components/HookForm/HookForm';
import Select from '../../../../components/Select/Select';
import { DEAL_STATUS_WAITING_FOR_FREEDOM, DEAL_STATUS_WAITING_FOR_REGISTRATION_DOCUMENTS } from '../../../../constants';

const FreedomCarRegistration = ({ onSubmit, loading }) => {
  return (
    <div style={{ marginBottom: 20 }}>
      <HookForm
        title={'Регистрация ТС'}
        grid={{ display: 'grid', gap: 20 }}
        action={'Сохранить и продолжить'}
        inputs={[
          {
            label: 'Статус сделки',
            name: 'status',
            component: Select,
            options: [
              {
                value: DEAL_STATUS_WAITING_FOR_REGISTRATION_DOCUMENTS,
                label: 'Ожидает постановки ТС на учет',
              },
              {
                value: DEAL_STATUS_WAITING_FOR_FREEDOM,
                label: 'Машина поставлена на учет',
              },
            ],
            required: true,
          },
        ]}
        onSubmit={onSubmit}
        loading={loading}
      />
    </div>
  );
};

export default FreedomCarRegistration;
